export default {
  badge: 'Abzeichen',
  open: 'Öffnen',
  close: 'Schließen',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Abbrechen',
  },
  dataIterator: {
    noResultsText: 'Keine Elemente gefunden',
    loadingText: 'Lade Elemente...',
  },
  dataTable: {
    itemsPerPageText: 'Zeilen pro Seite:',
    ariaLabel: {
      sortDescending: 'Absteigend sortiert.',
      sortAscending: 'Aufsteigend sortiert.',
      sortNone: 'Nicht sortiert.',
      activateNone: 'Aktivieren um Sortierung zu entfernen.',
      activateDescending: 'Aktivieren um absteigend zu sortieren.',
      activateAscending: 'Aktivieren um aufsteigend zu sortieren.',
    },
    sortBy: 'Sortiere nach',
  },
  dataFooter: {
    itemsPerPageText: 'Elemente pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
    pageText: '{0}-{1} von {2}',
  },
  dateRangeInput: {
    divider: 'bis',
  },
  datePicker: {
    itemsSelected: '{0} selected',
    range: {
      title: 'Daten auswählen',
      header: 'Daten eingeben',
    },
    title: 'Datum auswählen',
    header: 'Datum eingeben',
    input: {
      placeholder: 'Datum eingeben',
    },
  },
  noDataText: 'Keine Daten vorhanden',
  carousel: {
    prev: 'Vorheriges Bild',
    next: 'Nächstes Bild',
    ariaLabel: {
      delimiter: 'Element {0} von {1}',
    },
  },
  calendar: {
    moreEvents: '{0} mehr',
    today: 'Today',
  },
  input: {
    clear: '{0} leeren',
    prependAction: '{0} vorangestellte Aktion',
    appendAction: '{0} angehängte Aktion',
    otp: 'Bitte OTP-Zeichen {0} eingeben',
  },
  fileInput: {
    counter: '{0} Dateien',
    counterSize: '{0} Dateien ({1} gesamt)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      root: 'Seitennavigation',
      next: 'Nächste Seite',
      previous: 'Vorherige Seite',
      page: 'Gehe zu Seite {0}',
      currentPage: 'Aktuelle Seite, Seite {0}',
      first: 'Erste Seite',
      last: 'Letzte Seite',
    },
  },
  stepper: {
    next: 'Weiter',
    prev: 'Zurück',
  },
  rating: {
    ariaLabel: {
      item: 'Bewertung {0} von {1}',
    },
  },
  loading: 'Laden...',
  infiniteScroll: {
    loadMore: 'Mehr laden',
    empty: 'Nichts weiteres',
  },
}
